import { TYPOGRAPHY } from './typography';

// Colours are Chakra token names, not hex: Chakra resolves them to
// `--kula-colors-*` variables, which the dark palette re-declares. The same
// names as `COLORS` and the same light values.
export const TEXT_STYLES = {
  heading_1: {
    fontSize: TYPOGRAPHY.FONT_SIZE.LG,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.SEMIBOLD,
    color: 'secondary-900',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.MD,
  },
  heading_2: {
    fontSize: TYPOGRAPHY.FONT_SIZE.BASE,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.SEMIBOLD,
    color: 'secondary-900',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.BASE,
  },
  heading_3: {
    fontSize: TYPOGRAPHY.FONT_SIZE.SM,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.SEMIBOLD,
    color: 'secondary-900',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.SM,
  },
  heading_4: {
    fontSize: TYPOGRAPHY.FONT_SIZE.SM,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.MEDIUM,
    color: 'secondary-900',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.SM,
  },
  paragraph: {
    fontSize: TYPOGRAPHY.FONT_SIZE.SM,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.REGULAR,
    color: 'secondary-700',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.SM,
  },
  link: {
    fontSize: TYPOGRAPHY.FONT_SIZE.SM,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.MEDIUM,
    color: 'primary-500',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.SM,
  },
  overhead: {
    fontSize: TYPOGRAPHY.FONT_SIZE.XS,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.SEMIBOLD,
    color: 'secondary-600',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.XS,
    textTransform: 'uppercase',
  },
  small_text: {
    fontSize: TYPOGRAPHY.FONT_SIZE.XS,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.MEDIUM,
    color: 'secondary-700',
    lineHeight: TYPOGRAPHY.LINE_HEIGHT.XS,
  },
  tableHeader: {
    fontSize: TYPOGRAPHY.FONT_SIZE.SM,
    fontWeight: TYPOGRAPHY.FONT_WEIGHT.SEMIBOLD,
    color: 'secondary-900',
    textTransform: 'uppercase',
  },
} as const;
